module.exports = __webpack_public_path__ + "static/media/anagkazo_full.04f18079.png";